import cx from "classnames";
import {CheckOutlined} from "@ant-design/icons";
import React, {FC, useState} from "react";
import styles from "@/page-components/verify/Query/styles.module.less";

type TCheckItem = {
  activeMethod: number
  method: number;
  title: string;
  subtitle: string;
  onChange: (method: number) => void;
}

const CheckItem:FC<TCheckItem> = ({activeMethod,onChange,method,title,subtitle}) => {
  return(
    <div className={cx(styles.query_body_choose_item,method === activeMethod && styles.active)} onClick={() => {
      onChange(method);
    }}>
      <div className={styles.query_body_choose_item_title}>{title}</div>
      <div className={styles.query_body_choose_item_subtitle}>
        {subtitle}
      </div>
      <div className={styles.right_icon}>
        <CheckOutlined />
      </div>
    </div>
  )
}
export default CheckItem;
